import { CREATE_TRUCKING_URL, DELETE_TRUCKING_URL, LIST_TRUCKING_URL, UPDATE_TRUCKING_URL, VIEW_TRUCKING_URL } from "../../Helpers/url_helper";
import RQ from "./baseRQ";

const QUERY_KEY = 'truckings';
const REDIRECT_URL = '/app/truckings';

export const TruckingRQ = new RQ(
  QUERY_KEY,
  LIST_TRUCKING_URL,
  VIEW_TRUCKING_URL,
  CREATE_TRUCKING_URL,
  UPDATE_TRUCKING_URL,
  DELETE_TRUCKING_URL,
  REDIRECT_URL
);